/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */
import { Loader } from '@jutro/components';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { DatatableUtil, JobUtil } from '@xengage/gw-portals-util-js';
import { AccountService } from 'gw-capability-gateway-policy';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from '@jutro/router';
import messages from '../Accounts.messages';
import metadata from './OpenTransactions.metadata.json5';
import styles from './OpenTransactions.module.scss';

const openTransactionTablePageSize = 25;

class AccountOpenTransactions extends Component {
    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        openTransactionsResponse: '',
        openTransactionsDataTable: '',
        selectedTransactionType: '',
        searchFilter: '',
        responseTransactionData: [],
        isLoading: true,

        // 2025-03-26 - Debra Frum - DE16352 - Open Transactions filter not displaying results when more than one page of data
        // Initialize Open Transactions table pagination configuration
        pageConfig: {
            filterValue: "",
            page: 0,
            pageSize: openTransactionTablePageSize
        }
    };

    tableColumns = ["jobNumber", "status", "effectiveDate", "type", "policyNumber"];

    noLinkJobTypes = ['rewrite'];

    // US26374 - Adding multiple dropdown values for filtering
    policyTransactionTableConfig = {
        policyTransactionStatus: [],
    };

    componentDidMount() {
        this.getResponse();
        this.getPolicyTransactionStatus();
    };

    getResponse = async () => {
        const { authHeader, fromAccountLanding } = this.props;
        await AccountService.getOpenPolicyTransactionsForAccount(
            fromAccountLanding.accountDetailsData.accountNumber,
            authHeader
        ).then(res => {
            this.setState(
                {
                    responseTransactionData: res,
                },
                () => {
                    this.getData();
                }
            );
        });
    };   
    
    // US26374 - getting required data for OpenTransactions Table from response
    getTableData = (data) => {
        const { intl } = this.props;
        return (data && data.length > 0) ? data.map(openTransactionsInfo => {
            const openTransactions = {
                jobNumber: openTransactionsInfo.jobNumber,
                status: openTransactionsInfo.status,
                effectiveDate: intl.formatDate(
                    new Date(
                        openTransactionsInfo.policyEffectiveDate
                    ),
                    {
                        year: 'numeric',
                        month: 'numeric', // converting "Jan 01, 1999 to 1/1/1999"
                        day: 'numeric',
                    }
                ),
                policyDisplayStatus: openTransactionsInfo.status,
                type: openTransactionsInfo.displayType,
                policyNumber: openTransactionsInfo.policyNumber,
                canUserView: openTransactionsInfo.canUserView,
                jobType: openTransactionsInfo.type,
            };
            return openTransactions;
        }) : [];
    };

    getData = () => {
        const response = this.getOpenTransactionsModelResponse();
        const translator = this.context;
        const filter = {
            type: null,
            value: null,
        };
        this.getOpenTransactionsDataTable(response, filter);
        this.setState({
            openTransactionsResponse: response,
            selectedTransactionType: translator(messages.allTransaction),
            isLoading: false,
        });
    };

    getOpenTransactionsModelResponse = () => {
        const { responseTransactionData } = this.state;
        const openTransactionsData = this.getTableData(responseTransactionData);
        return {
            openTransactionsData,
            transactionsOptions: this.getTransactionsOptions(),
        };
    };

    getFilterValues = (openTransactionsArrayResult, filter) => _.filter(openTransactionsArrayResult, res => res.status === filter.value);

    getSearchFilterValues = (openTransactionsArrayResult, filter) => {
        const lowerCaseFilterValue = filter.value.toLocaleLowerCase();
        return _.filter(openTransactionsArrayResult, res => Object.keys(res).some(
                key =>
                    _.includes(this.tableColumns, key) && typeof res[key] === 'string' &&
                    res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
            ));
    };

    getOpenTransactionsDataTable = (openTransactionsData, filter) => {
        const { searchFilter, selectedTransactionType } = this.state;
        let openTransactionsArrayResult =
            openTransactionsData.openTransactionsData;
        const combineFilter = {};
        switch (filter.type) {
            case 'statusFilter':
                openTransactionsArrayResult = this.getFilterValues(
                    openTransactionsArrayResult,
                    filter
                );
                if (searchFilter) {
                    combineFilter.value = searchFilter;
                    openTransactionsArrayResult = this.getSearchFilterValues(
                        openTransactionsArrayResult,
                        combineFilter
                    );
                }
                break;
            case 'SearchFilter':
                openTransactionsArrayResult = this.getSearchFilterValues(
                    openTransactionsArrayResult,
                    filter
                );
                if (
                    typeof selectedTransactionType === 'string' &&
                    selectedTransactionType !== 'All'
                ) {
                    combineFilter.value = selectedTransactionType;
                    openTransactionsArrayResult = this.getFilterValues(
                        openTransactionsArrayResult,
                        combineFilter
                    );
                }
                break;
            case null:
                if (searchFilter) {
                    combineFilter.value = searchFilter;
                    openTransactionsArrayResult = this.getSearchFilterValues(
                        openTransactionsArrayResult,
                        combineFilter
                    );
                }
                break;
            default:
                openTransactionsArrayResult =
                    openTransactionsData.openTransactionsData;
                break;
        }

        openTransactionsArrayResult.sort((a, b) => 
             new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime() // sorting by effectiveDate insted of jobNumber
        );
        this.setState({
            openTransactionsDataTable: openTransactionsArrayResult,
        });

        // 2025-03-26 - Debra Frum - DE16352 - Open Transactions filter not displaying results when more than one page of data
        // When a filter is changed on the Open Transactions table, reset the table page number to 0 
        const { pageConfig } = this.state
        pageConfig.page = 0
        this.setState({
            pageConfig
        })
    };

    getTransactionsOptions = () => {
        const translator = this.context;
        const transactionsOptionsArray = [
            translator(messages.allTransaction),
            translator(messages.draftTransaction),
        ];
        return transactionsOptionsArray.map(key => ({
                code: key,
                name: key,
            }));
    };
    
    getPolicyTransactionStatus = () => {
        const translator = this.context;
        const status = [{
                code: 'All',
                name: translator(messages.allTransaction)
            }, {
                code: 'Draft',
                name: translator(messages.draftTransaction)
            }, {
                code: 'Quoted',
                name: translator(messages.quoted)
            }, {
                code: 'Non-renewing', // DE16349
                name: translator(messages.nonRenewing)
            }, {
                code: 'Renewing',
                name: translator(messages.renewing)
            },
            {
                code: 'Offer Submitted', // DE16348
                name: translator(messages.submitted),
            }
        ];

        this.policyTransactionTableConfig.policyTransactionStatus = status;
        this.setState({
            selectedTransactionType : status[0] // All
        });
    }

    handleFilterChange = (value, id) => {
        const { openTransactionsResponse } = this.state;
        const filter = {
            type: null,
            value: null,
        };
        if (id === 'statusFilter') {
            if (value !== 'All') {
                filter.type = 'statusFilter';
                filter.value = value;
            }
            this.setState(
                {
                    selectedTransactionType: value,
                },
                () => {
                    this.getOpenTransactionsDataTable(
                        openTransactionsResponse,
                        filter
                    );
                }
            );
        }
        if (id === 'searchFilter') {
            filter.type = 'SearchFilter';
            filter.value = value;
            this.setState(
                {
                    searchFilter: value,
                },
                () => {
                    this.getOpenTransactionsDataTable(
                        openTransactionsResponse,
                        filter
                    );
                }
            );
        }
    };

    getLink = (item, index, property) => {
        // DE16350 - show transaction number for rewrite and reinstatement
        // const transactionTypeIsViewableInXCenter =
        //     // item.jobType.toLowerCase() !== 'reinstatement' &&
        //     // item.jobType.toLowerCase() !== 'rewrite';        
        if(this.noLinkJobTypes.includes(item.jobType.toLowerCase())){
            return (<span>{item[property.id]}</span>)
        }
        if (item.canUserView) {
            if (!this.showOpenJobInXCenter(item.jobType)) {
                return (
                    <span>
                        <Link
                            href="/"
                            onClick={() =>
                                JobUtil.openJobInXCenter(item.jobNumber)
                            }
                        >
                            {item[property.id]}
                        </Link>
                    </span>
                );
            }
            return (
                <span>
                    <Link
                        to={JobUtil.getJobDetailURLByJobType(
                            item.jobType,
                            item.jobNumber
                        )}
                    >
                        {item[property.id]}
                    </Link>
                </span>
            );
        }
        return null;
    };

    showOpenJobInXCenter = type => (
            type === 'Submission' ||
            type === 'PolicyChange' ||
            type === 'Cancellation' ||
            type === 'Renewal'
        );

    getCell = (items, index, property) => items[property.id] ? items[property.id] : '-';

    getPolicyNumber = (item, index, property) => item[property.id] ? (
            <span>
                <Link to={`/policies/${item[property.id]}/summary`}>
                    {item[property.id]}
                </Link>
            </span>
        ) : (
            '-'
        );

    render() {
        const {
            openTransactionsDataTable,
            selectedTransactionType,
            searchFilter,
            isLoading,
        } = this.state;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }
        const overrides = {
            openTransactionDataTable: {
                data: openTransactionsDataTable,

                // 2025-03-26 - Debra Frum - DE16352 - Open Transactions filter not displaying results when more than one page of data
                // When a filter is changed on the Open Transactions table, reset the table page number to 0 
                // if the current page is greater than 0
                config: this.state.pageConfig,
                onConfigChange: (data) => {
                    const pageConfig = _.clone(data)
                    if (openTransactionsDataTable.length <= openTransactionTablePageSize) {
                        pageConfig.page = 0
                    }
                    this.setState({
                        pageConfig
                    })
                }
            },
            dropDownFilter: {
                availableValues: this.policyTransactionTableConfig.policyTransactionStatus,
                value: selectedTransactionType,
            },
            searchFilter: {
                value: searchFilter,
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getLink: this.getLink,
                getPolicyNumber: this.getPolicyNumber,
                handleStatusValueChange: value =>
                    this.handleFilterChange(value, 'statusFilter'),
                handleSearchValueChange: value =>
                    this.handleFilterChange(value, 'searchFilter'),
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortNumber: DatatableUtil.sortNumber,
            },
        };
        const openTransactionPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        return (
            <div className={styles.openTransaction}>{openTransactionPage}</div>
        );
    }
}

export const AccountOpenTransactionsComponent = AccountOpenTransactions;
export default withIntl(withAuthenticationContext(AccountOpenTransactions));
